// extracted by extract-css-chunks-webpack-plugin
module.exports = {"frequency-selector":"payment-entry-recurring-edit__frequency-selector___1jZuz","frequencySelector":"payment-entry-recurring-edit__frequency-selector___1jZuz"};
    if(module.hot) {
      // 1679366653570
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  